"use client";

import { getOverCapacityType, isOverCapacityError } from "./detector";
import { useOverCapacity } from "./provider";

/**
 * Server Action用のOver Capacityエラーハンドリングヘルパー関数
 * Server Actionの結果をチェックして、Over Capacityエラーの場合はモーダルを表示する
 */
export function useServerActionErrorHandler() {
  const { showOverCapacityError } = useOverCapacity();

  /**
   * Server Actionの結果をチェックして、Over Capacityエラーの場合はモーダルを表示
   * @param result Server Actionの結果
   * @returns Over Capacityエラーが検出された場合はtrue、それ以外はfalse
   */
  const handleServerActionError = (result: {
    error?: string;
    errors?: string[];
    errorDetails?: { email: string; message: string }[];
  }): boolean => {
    // 単一エラーの場合
    if (result.error && isOverCapacityError(result.error)) {
      const errorType = getOverCapacityType(result.error);
      showOverCapacityError(errorType || result.error);
      return true;
    }

    // 複数エラーの場合（errorsが配列の場合）
    if (result.errors && Array.isArray(result.errors)) {
      const overCapacityError = result.errors.find((error) =>
        isOverCapacityError(error),
      );
      if (overCapacityError) {
        const errorType = getOverCapacityType(overCapacityError);
        showOverCapacityError(errorType || overCapacityError);
        return true;
      }
    }

    // エラー詳細の場合（errorDetailsが配列の場合）
    if (result.errorDetails && Array.isArray(result.errorDetails)) {
      const overCapacityError = result.errorDetails.find((detail) =>
        isOverCapacityError(detail.message),
      );
      if (overCapacityError) {
        const errorType = getOverCapacityType(overCapacityError.message);
        showOverCapacityError(errorType || overCapacityError.message);
        return true;
      }
    }

    return false;
  };

  return { handleServerActionError };
}
